import { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import EnrollmentBanner from "../components/EnrollmentBanner";
import Services from "../components/Services";
import Manifesto from "../components/Manifesto";
import Process from "../components/Process";
import BlogSection from "../components/BlogSection";
import Faq from "../components/Faq";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { scrollToId } from "../components/RouteScroll";
import { Seo } from "../components/Seo";
import { PAGES, HOME_JSON_LD } from "../lib/seo";

export default function Home() {
  const contactRef = useRef(null);
  const scrollToContact = () => scrollToId("contact");
  const sections = [
    <Marquee key="marquee" />,
    <Services key="services" onQuote={scrollToContact} />,
    <Manifesto key="manifesto" />,
    <Process key="process" />,
    <BlogSection key="blog" />,
    <Faq key="faq" />,
    <Contact key="contact" ref={contactRef} />,
  ];
  const [shown, setShown] = useState(0);
  useEffect(() => {
    if (shown > sections.length) return;
    const id = requestAnimationFrame(() => setShown((n) => n + 1));
    return () => cancelAnimationFrame(id);
  }, [shown, sections.length]);

  return (
    <>
      <Seo {...PAGES.home} jsonLd={HOME_JSON_LD} />
      <Navbar />
      <main>
        <Hero onQuote={scrollToContact} />
        <EnrollmentBanner onQuote={scrollToContact} />
        {sections.slice(0, shown)}
      </main>
      {shown > sections.length && <Footer />}
    </>
  );
}
